module.exports = __webpack_public_path__ + "static/img/challenge_warriors_bg.6fcc0aff.png";